var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 mt-4"},[(_vm.useButton)?_c('apply-button',{on:{"selectForm":_vm.showAppForm}}):_c('apply-buttons',{on:{"selectForm":_vm.showAppForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }